import { render, staticRenderFns } from "./ContentImagesTable.vue?vue&type=template&id=6c5e98d9&scoped=true&"
import script from "./ContentImagesTable.vue?vue&type=script&lang=ts&"
export * from "./ContentImagesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContentImagesTable.vue?vue&type=style&index=0&id=6c5e98d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e98d9",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QAvatar,QImg});
